function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.711914 12.9385H6.2666C6.67969 12.9385 6.96973 12.6836 6.96973 12.2705C6.96973 11.875 6.68848 11.6201 6.27539 11.6201H4.29785L6.43359 1.68848H8.40234C8.81543 1.68848 9.10547 1.43359 9.10547 1.02051C9.10547 0.625 8.82422 0.370117 8.41113 0.370117H2.83887C2.42578 0.370117 2.14453 0.625 2.14453 1.02051C2.14453 1.43359 2.43457 1.68848 2.84766 1.68848H4.80762L2.67188 11.6201H0.703125C0.290039 11.6201 0 11.875 0 12.2705C0 12.6836 0.298828 12.9385 0.711914 12.9385Z",
  fill: "#B2B2BF"
});

function SvgIconItalic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconItalic);
export default __webpack_public_path__ + "static/media/icon-italic.eeeaecb8.svg";
export { ForwardRef as ReactComponent };